export default "__VITE_ASSET__RKAFvI2J__"